module.exports = __webpack_public_path__ + "img/resources-375.56400d28.jpg";